import {LABELS as _LABELS} from "../../../language";

const LABELS=_LABELS.settingPage;

const validate = values => {
    const errors = {};
    const requiredFields = [
        "name",
        "timezone",
        "line1",
        "city",
        "state",
        "zip",
        "country"
    ];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = `${LABELS.required}`;
        }
    });
    return errors;
};

export default validate;
